import { Box, styled } from '@mui/material';
import React from 'react';
import { ClientLogoWithText } from 'src/lib/components/LogoWithText';
import BrandLogo, { VendorLogo } from './BrandLogo';

const Wrapper = styled('div')<{ width: number }>(({ theme, width }) => ({
    flex: 'auto',
    padding: '60px 0',
    [`@media (max-width: ${width}px)`]: {
        padding: 0,
        background: theme.resqPalette.surface.default,
    },
}));

const Paper = styled('div')<{
    width: number;
}>(({ theme, width }) => ({
    margin: '0 auto',
    width: '100%',
    background: theme.resqPalette.surface.default,
    padding: '32px',
    border: `1px solid ${theme.resqPalette.border.subdued}`,
    borderRadius: '8px',
    boxShadow: `0px 4px 8px ${theme.resqPalette.border.subdued}`,
    maxWidth: `${width}px`,
    [`@media (max-width: ${width}px)`]: {
        border: 'none',
        borderRadius: 0,
        boxShadow: 'none',
    },
}));

const Body = styled('div')``;

interface Props {
    width: number;
    children: React.ReactNode;
    isVendor?: boolean;
    logoSubheading?: boolean;
}

const Container = ({ width, children, isVendor, logoSubheading }: Props) => {
    if (logoSubheading) {
        return (
            <Wrapper width={width}>
                {isVendor ? (
                    <Box mb={4}>
                        <VendorLogo />
                    </Box>
                ) : (
                    <ClientLogoWithText />
                )}
                <Paper width={width}>
                    <Body>{children}</Body>
                </Paper>
            </Wrapper>
        );
    }

    return (
        <Wrapper width={width}>
            <Paper width={width}>
                <BrandLogo vendor={isVendor} />
                <Body>{children}</Body>
            </Paper>
        </Wrapper>
    );
};

export default Container;
